import React, { useEffect, useRef, useState } from "react";
import "./Dashboard.css";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteResume, saveResumeTitle, uploadResume, view_resume } from "../../Api/apiService.js";
import { useDispatch, useSelector } from "react-redux";
import LayoutHOC from "../../Components/Hoc/ResumeHoc.jsx";
import ContainerWrapper from "../../Components/ContainerWrapper/container-wrapper.jsx";
import CustomInput from "../../Components/Input/Custom-Input.jsx";
import { Col, Row } from "antd";
import CustomizeButton from "../../Components/Button/Customize-Button.jsx";
import CreateResumeWrapper from "../CreateResume/components/Create-Resume-Wrapper.jsx";
import EmployeeSidebar from "../../Components/Sidebar/Employee-Sidebar.jsx";
import ModalNew from "../../Components/Modal/modal-new.jsx";
import InputWrapper from "../../Components/Input/Input-Wrapper.jsx";
import ViewResumeDashboard from "./components/view-resume-dashboard.jsx";
import { selectProfile } from "../../Redux/ResumeReducer/ResumeAction.js";
import { toast } from "react-toastify";

function Dashboard() {
  const [showCreateResumeModal, setShowCreateResumeModal] = useState(false);
  const [resumeTitle, setResumeTitle] = useState("");
  const [id, setId] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const userId = useSelector((state) => state.auth);
  const user = JSON.parse(localStorage.getItem("auth")) || {};
  const name = user?.name;

  const [selectedProfileId, setSelectedProfileId] = useState(null);
  const [showDeleteResumeModal, setShowDeleteResumeModal] = useState(false);
  const [deletedProfileId, setDeletedProfileId] = useState(null);
  const [employeeResumeUpload, setEmployeeResumeUpload] = useState(false);
  const resumeRef = useRef();

  console.log(userId, "this is Id");

  const fetchProfiles = async () => {
    setLoading(true);
    try {
      const response = await view_resume(userId.userId);
      const activeProfiles = response.data.filter((profile) => !profile.isDeleted);
      console.log(activeProfiles, "these are active profiled");
      setProfiles(activeProfiles);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const confirmDelete = async () => {
    if (!deletedProfileId) return;
    try {
      const deleteResponse = await deleteResume(deletedProfileId);
      if (deleteResponse.data.isDeleted) {
        setShowDeleteResumeModal(false);
        if (selectedProfileId === deletedProfileId) {
          setSelectedProfileId(null);
          dispatch(selectProfile(null));
        }
        fetchProfiles();
        toast.success("Resume deleted successfully!", { autoClose: 1500 });
        setDeletedProfileId(null);
      }
    } catch (error) {
      console.log("Failed to delete resume");
    }
  };
  const handleDeleteProfile = (profileId) => {
    console.log("Delete profile with ID:", profileId);
    setDeletedProfileId(profileId);
    setShowDeleteResumeModal(true);
    dispatch(selectProfile([]));
  };

  const handleSelectProfile = (profileId) => {
    setSelectedProfileId(profileId);
    const selectedProfile = profiles.find((p) => p.id === profileId);

    console.log(selectedProfile, "selected profile");
    if (selectedProfile) {
      dispatch(selectProfile(selectedProfile));
    }
  };
  useEffect(() => {
    fetchProfiles();
  }, []);

  useEffect(() => {
    if (profiles.length > 0 && !selectedProfileId) {
      setSelectedProfileId(profiles[0].id);
    }
  }, [profiles]);

  console.log(userId);

  const handleUploadResume = async (e) => {
    e.preventDefault();
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      toast.error("Please select a file to upload.", {
        autoClose: 2000,
      });
      return;
    }

    const formData = new FormData();
    formData.append("resume", selectedFile);
    formData.append("userId", id);
    formData.append("role", userId.role);
    console.log(formData.get("role"));
    console.log(formData.get("userId"));

    try {
      const response = await uploadResume(formData);

      if (response?.status === 200 || response?.status === 201) {
        toast.success(response?.data?.message || "PDF Resume uploaded successfully!", {
          autoClose: 2000,
        });
        // setRefreshResumeList(!refreshResumeList);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };

  const handleTitleSave = async () => {
    dispatch(selectProfile([]));
    try {
      const response = await saveResumeTitle(resumeTitle, userId.userId);
      if (response?.status === 200 || response?.status === 201) {
        window.localStorage.setItem("profileId", response.data.id);
        toast.success(response?.data?.message || "Resume Title Saved", {
          autoClose: 2000,
        });
        setTimeout(() => {
          navigate("/personalInfo");
        }, 3000);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };

  const handleTitleSaveUpload = async () => {
     if (!resumeTitle || !resumeTitle) {
            toast.error("Please select an employee and enter a resume title.", {
              autoClose: 2000,
            });
            return;
          }
      
    try {
      const response = await saveResumeTitle(resumeTitle, userId.userId);
      if (response?.status === 200 || response?.status === 201) {
        window.localStorage.setItem("profileId", response.data.id);
        setId(response.data.id);
        console.log(id);

        toast.success(response?.data?.message || "Resume Title Saved", {
          autoClose: 1000,
        });

        setTimeout(() => {
          document.getElementById("resume").click();
          console.log("uploading resume");
        }, 3000);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };

  const handleEdit = (profile) => {
    const selectedProfile = profiles.find((p) => p.id === profile.id);

    console.log(selectedProfile, "selected profile");
    if (selectedProfile) {
      dispatch(selectProfile(selectedProfile));
    }

    window.localStorage.removeItem("profileId");

    window.localStorage.setItem("profileId", profile.id);

    navigate(`/personalInfo/?profileId=${profile.id}`);
  };
  const colSpan = profiles.length > 0 ? 18 : 24;

  return (
    <>
      <div className="dashboard-container-outer">
        <ContainerWrapper breadcrumbItems={["Dashboard"]}>
          <div className="dashboard-inner-container">
            <Row
              style={{
                marginBottom: "12px",
              }}
            >
              <Col span={8}>
                <span
                  style={{
                    fontWeight: "500",
                    fontSize: "24px",
                    marginBottom: "20px",
                    color: "#464646",
                  }}
                >
                  Welcome to Resume Builder {name}
                </span>
              </Col>
              <Col span={16}>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "flex-end",
                  }}
                >
                  <CustomizeButton variant="primary" onClick={() => setShowCreateResumeModal(true)}>
                    {" "}
                    Create Resume{" "}
                  </CustomizeButton>
                  <CustomizeButton variant="primary" onClick={()=>{
                    setEmployeeResumeUpload(true);
                  }}> Upload Resume </CustomizeButton>
                  {/* <input 
      id="resume" 
      type="file" 
      accept="application/pdf" 
      style={{ display: "none" }} 
      onChange={handleEmployeeResumeUpload} 
    /> */}
                </div>
              </Col>
            </Row>
            <Row gutter={[20, 20]}>
              {profiles.length > 0 && (
                <Col span={6}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div>
                      <EmployeeSidebar
                        profiles={profiles}
                        title="Resumes"
                        userId={userId.userId}
                        onSelectProfile={handleSelectProfile}
                        onEditProfile={handleEdit}
                        onDeleteProfile={handleDeleteProfile}
                        selectedProfileId={selectedProfileId}
                        onDownloadPDF={() => resumeRef.current?.downloadPDF()}
                        onDownloadWord={() => resumeRef.current?.downloadWord()}
                      />
                    </div>
                  </div>
                </Col>
              )}
              <Col span={colSpan}>
                <CreateResumeWrapper>
                  <div
                    style={{
                      borderRadius: "10px",
                      padding: "16px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <ViewResumeDashboard ref={resumeRef} userId={userId.userId} profileId={selectedProfileId} />
                  </div>
                </CreateResumeWrapper>
              </Col>
            </Row>
          </div>
        </ContainerWrapper>

        <ModalNew onClose={() => setShowCreateResumeModal(false)} title={"Create Resume"} visible={showCreateResumeModal}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <InputWrapper
              style={{
                width: "100%",
              }}
              label={"Enter Resume Title"}
              required
            >
              <CustomInput value={resumeTitle} onChange={(e) => setResumeTitle(e.target.value)} />
            </InputWrapper>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CustomizeButton
                style={{
                  width: "14vw",
                }}
                variant="primary"
                onClick={() => {
                  handleTitleSave();
                }}
              >
                Create Resume
              </CustomizeButton>
            </div>
          </div>
        </ModalNew>
        <ModalNew
          className="delete-modal"
          title={"Delete Resume"}
          visible={showDeleteResumeModal}
          onClose={() => {
            setShowDeleteResumeModal(false);
            setDeletedProfileId(null);
          }}
        >
          <div className="selector-container">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  color: "#000000",
                }}
              >
                Are you sure you want to delete this resume?
              </span>
            </div>

            <div style={{ display: "flex", gap: "10px", width: "100%", marginTop: "20px" }}>
              <CustomizeButton
                style={{
                  width: "50%",
                }}
                variant="primary"
                onClick={confirmDelete}
              >
                Confirm
              </CustomizeButton>

              <CustomizeButton
                style={{
                  width: "50%",
                }}
                variant="outlined"
                onClick={() => setShowDeleteResumeModal(false)}
              >
                Cancel
              </CustomizeButton>
            </div>
          </div>
        </ModalNew>

        <ModalNew title="Enter Resume Title" visible={employeeResumeUpload} onClose={() => setEmployeeResumeUpload(false)}>
          <div className="selector-container">
            <div>
              <InputWrapper label="Enter Resume Title" required>
                <CustomInput
                  onChange={(e) => {
                    setResumeTitle(e.target.value);
                  }}
                  className="role-selector"
                  placeholder="Enter Resume Title"
                />
              </InputWrapper>
            </div>
            <div style={{ display: "flex", gap: "10px", width: "100%", marginTop: "20px" }}>
              <CustomizeButton onClick={handleTitleSaveUpload} className="navigate-btn" variant="primary">
                {" "}
                Save{" "}
              </CustomizeButton>
              <CustomizeButton
                onClick={() => {
                  setEmployeeResumeUpload(false);
                }}
                className="navigate-btn"
                variant="outlined"
              >
                {" "}
                Cancel{" "}
              </CustomizeButton>
              <input 
      id="resume" 
      type="file" 
      accept="application/pdf" 
      style={{ display: "none" }} 
      onChange={handleUploadResume} 
    />
            </div>
          </div>
        </ModalNew>
      </div>
    </>
  );
}

export default LayoutHOC(Dashboard, { withSidebar: false });
